import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useAuth } from '../context/auth'

const NotFound = () => {
  const navigate = useNavigate()
  const { state } = useAuth()
  const redirectAfterLogin = localStorage.getItem('redirectAfterLogin')
  const [countdown, setCountdown] = useState(4)

  useEffect(() => {
    if (!state.isAuthenticated) setCountdown(0)

    if (redirectAfterLogin && state.isAuthenticated) {
      localStorage.removeItem('redirectAfterLogin')
      navigate(redirectAfterLogin, { state: { from: redirectAfterLogin } })
    }
  }, [redirectAfterLogin])

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prevCountdown) => {
        return prevCountdown - 1
      })
    }, 1000)

    if (countdown === 0) {
      if (state.isAuthenticated) {
        localStorage.removeItem('redirectAfterLogin')
      }
      navigate('/login')
    }

    return () => clearInterval(interval)
  }, [countdown, navigate])

  if ((redirectAfterLogin && !state.isAuthenticated) || countdown === 4) return null

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <p className="text-title-xl text-red-700 font-bold mb-8">
        Podana strona nie istnieje.
      </p>
      <p className="text-2xl font-bold mb-4">
        Za {countdown} {countdown === 1 ? 'sekundę' : 'sekundy'} zostaniesz
        przekierowany na stronę główną.
      </p>
      <p className="text-gray-600">Proszę czekać...</p>
    </div>
  )
}

export default NotFound
